import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {LearningProgressInsightService} from '../LearningProgressInsightService';
import {StudyProgressRessource} from './study-progress-ressource.service';
import {LearningPackageInsightsDetailsResponseDto} from './api-types/LearningPackageInsightsDetailsResponseDto';
import {ChatStartService} from '../../components/chatbot/chat-start.service';
import {ConversationRessource} from './conversation-ressource.service';
import {TAB_NAVIGATION_SERVICE, TabNavigationService} from '../TabNavigationService';
import {PopupService} from '../../components/popup/popup.service';
import {LearningPackageInsightsQuestionsResponseDto} from './api-types/LearningPackageInsightsQuestionsResponseDto';
import {TimePeriodMode} from './api-types/TimePeriodMode';
import {LearningProgressHistoryResponseDto} from './api-types/LearningProgressHistoryResponseDto';
import {switchMap, take} from 'rxjs/operators';
import {
    ImpersonationService
} from '../../../../../micromate-learn-web/src/app/core/authentication/impersonation.service';
import {
    LearningPackageInsightsSkillsProfileResponseDto
} from './api-types/LearningPackageInsightsSkillsProfileResponseDto';
import {LearningPackageInsightsTopicsResponseDto} from './api-types/LearningPackageInsightsTopicsResponseDto';
import {BotatoChatManagerService} from 'botato-angular-lib';

@Injectable({
    providedIn: 'root'
})
export class LearnLearningProgressInsightService implements LearningProgressInsightService {

    constructor(private studyProgressRessource: StudyProgressRessource,
                private chatStartService: ChatStartService,
                private conversationRessource: ConversationRessource,
                private botatoChatManager: BotatoChatManagerService,
                @Inject(TAB_NAVIGATION_SERVICE) private tabNavigationService: TabNavigationService,
                private popupService: PopupService,
                private impersonationService: ImpersonationService) {
    }


    public getLearningProgressInsightDetails(learningPackageId: string): Observable<LearningPackageInsightsDetailsResponseDto> {
        return this.impersonationService.isImpersonationMode$.pipe(
            take(1),
            switchMap(isImpersonationMode => {
                if (isImpersonationMode) {
                    return this.impersonationService.impersonatedLearnerId$.pipe(
                        take(1),
                        switchMap(impersonatedLearnerId => this.studyProgressRessource.getLearnerLearningProgressInsightDetailsForLearn(learningPackageId, impersonatedLearnerId))
                    );
                }
                return this.studyProgressRessource.getLearnerLearningProgressInsightDetailsForLearn(learningPackageId);
            })
        );
    }

    public getLearningProgressInsightQuestionsOverview(learningPackageId: string): Observable<LearningPackageInsightsQuestionsResponseDto> {
        return this.impersonationService.isImpersonationMode$.pipe(
            take(1),
            switchMap(isImpersonationMode => {
                if (isImpersonationMode) {
                    return this.impersonationService.impersonatedLearnerId$.pipe(
                        take(1),
                        switchMap(impersonatedLearnerId => this.studyProgressRessource.getLearnerLearningProgressInsightQuestionsForLearn(learningPackageId, impersonatedLearnerId))
                    );
                }
                return this.studyProgressRessource.getLearnerLearningProgressInsightQuestionsForLearn(learningPackageId);
            })
        );
    }

    public learnLearningPackage(learningPackageId: string): void {
        this.chatStartService.isWaitingForNotification = true;
        this.botatoChatManager.showTypingIndicator();
        void this.conversationRessource.selectLearningPackage(learningPackageId);
        this.popupService.close();
        setTimeout(() => {
            this.tabNavigationService.navigateToChat(false);
        }, 0)
    }

    public getLearningProgressInsightHistory(learningPackageId: string, timePeriodMode: TimePeriodMode): Observable<LearningProgressHistoryResponseDto> {
        return this.impersonationService.isImpersonationMode$.pipe(
            take(1),
            switchMap(isImpersonationMode => {
                if (isImpersonationMode) {
                    return this.impersonationService.impersonatedLearnerId$.pipe(
                        take(1),
                        switchMap(impersonatedLearnerId => this.studyProgressRessource.getLearnerLearningProgressHistoryForLearn(learningPackageId, timePeriodMode, impersonatedLearnerId))
                    );
                }
                return this.studyProgressRessource.getLearnerLearningProgressHistoryForLearn(learningPackageId, timePeriodMode);
            })
        );
    }

    public getSkillsProfileInsightHistory(learningPackageId: string): Observable<LearningPackageInsightsSkillsProfileResponseDto> {
        return this.impersonationService.isImpersonationMode$.pipe(
            take(1),
            switchMap(isImpersonationMode => {
                if (isImpersonationMode) {
                    return this.impersonationService.impersonatedLearnerId$.pipe(
                        take(1),
                        switchMap(impersonatedLearnerId => this.studyProgressRessource.getLearnerLearningProgressInsightSkillsProfileForLearn(learningPackageId, impersonatedLearnerId))
                    );
                }
                return this.studyProgressRessource.getLearnerLearningProgressInsightSkillsProfileForLearn(learningPackageId);
            })
        );
    }

    public getLearningProgressInsightTopicsOverview(learningPackageId: string): Observable<LearningPackageInsightsTopicsResponseDto> {
        return this.impersonationService.isImpersonationMode$.pipe(
            take(1),
            switchMap(isImpersonationMode => {
                if (isImpersonationMode) {
                    return this.impersonationService.impersonatedLearnerId$.pipe(
                        take(1),
                        switchMap(impersonatedLearnerId => this.studyProgressRessource.getLearnerLearningProgressInsightTopicsForLearn(learningPackageId, impersonatedLearnerId))
                    );
                }
                return this.studyProgressRessource.getLearnerLearningProgressInsightTopicsForLearn(learningPackageId);
            })
        );
    }
}
